import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core";
import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";

function Footer({ ...props }) {
  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });

  return (
    <footer className={footerClasses + ' footerbottom'}>
      <div className={classes.container}>
        <div className={classes.left + ' dessignby'}>
          <span>
            طراحی توسط :
            <a href='http://sorali.ir'>
              Sorali.ir
            </a>
          </span>
        </div>
        <div className={classes.right + ' allrights'}>
          &copy; {1900 + new Date().getYear()} ,تمامی حقوق برای سبا محفوط است

        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);
